export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#F15C21',
    light: '#F6F6F6',
  },
  secondary: {
    main: '#1D5D7C',
    contrastText: '#FFFFFF',
    light: '#D9EDF7',
  },
  text: {
    primary: '#1D5D7C',
    secondary: '#757575',
    alternate: '#4D4D4D',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
    subtitle: '#4D4D4D',
    title: '#F79861',
    howitworkssubtitle: '#697883'
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    fill: '#f7f7f7',
    main: '#FFFFFF',
    paper: '#FFF',
    default: '#FFF',
    header: '#1D5D7C',
    footer: '#F6F6F6',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#1D5D7C',
    tableSubhead: '#F6FBFF',
    tableBorder: '#7D808880',
    tableAlternate: '#FFFFFF',
    alternate: '#E5EAF4',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#E9EDEF80',
    secondary: '#F8D859',
    light: '#F8FBFE',
    secondaryLight: 'rgba(238, 246, 250, 0.6)',
    primaryLight: '#D9EDF7',
    ribbon: '#bbe6fb',
  },
  surface: {
    grey: '#F6FBFF',
    savings: '#88D1CD',
    learnMore: '#F4F4F4',
    header: '#FFFFFF'
  },
  verticalBar: {
    used: '#687462',
    unused: '#F6F6F6',
    unlimited: '#C0C0C0',
  },
};
